// extracted by mini-css-extract-plugin
export default {"btns":"More_btns__dBGLP","MoreBtn":"More_MoreBtn__4YYBl","btnstyle":"More_btnstyle__8gJa1"};